import Skeleton from "react-loading-skeleton";

import styles from "./styles.module.scss";

export function StatisticCardSkeleton() {
  return (
    <div className={styles.container}>
      <Skeleton width={"100%"} height={"5rem"} count={4} />
    </div>
  );
}
